<template>
  <el-select
    v-model="valueBackup"
    placeholder="请选择课程注意事项"
    :disabled="disabled"
  >
    <el-option
      v-for="v in list"
      :key="v.id"
      :label="v.title"
      :value="v.id"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/course-tip';

export default {
  props: {
    value: [Number, String],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (value === this.valueBackup) return;
      this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;
      this.$emit('input', valueBackup);
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await index({ is_all: 1 });
      if (!isError) this.list = data;
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    this.getList();
  },
};
</script>
